import React from 'react';
import './card533Img.scss';
import Category from '../../category/Category';
import { MonTextS14W300LH22, MonTextS24W600LH32Ls05Minu } from '../../texts/fontText/montserrat/TextMon';
import DateText from '../../texts/dateText/DateText';
import ReadMore from '../../buttons/readMore/ReadMore';
import { ICategory } from '../../../tpyes/comment';
import { useNavigate } from 'react-router-dom';

interface IMainNews {
  title?: string;
  short_content?: string;
  subtitle?: string;
  image?: string;
  category?: ICategory | undefined;
  published_at?: string;
  updated_at?: string;
  id?: number;
  isMobile?: string;
}
const Card533Img = ({ title, subtitle, image, category, updated_at, published_at, id, isMobile }: IMainNews) => {
  const { name } = category || { name: '' };
  const navigate = useNavigate();
  // if (count) {
  //   (count + 1) % 6 >= 4 ? setMargin('mt-10') : '';
  // }

  // key 값을 받고 싶어

  return (
    <div className={`card533Img`}>
      <div className="card-container flex fd-col">
        <img onClick={() => navigate(`/news/${id}`)} src={image} alt="card5" className="card_img border obj-f-cover" />
        <div className="text-box">
          <div className="category-box">
            <Category value={name} />
          </div>

          <div onClick={() => navigate(`/news/${id}`)}>
            <MonTextS24W600LH32Ls05Minu text={title} />
          </div>

          <div className="detail-box">
            <MonTextS14W300LH22 text={subtitle} />
          </div>
          <div className="date-box">
            <DateText date={published_at || updated_at || 'default_date'} />
          </div>

          {isMobile === 'mobile' ? null : <ReadMore id={+id!} />}
        </div>
      </div>
    </div>
  );
};

export default Card533Img;
